import script from "./DataDisplayPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DataDisplayPage.vue?vue&type=script&setup=true&lang=js"

import "./DataDisplayPage.vue?vue&type=style&index=0&id=532873da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-532873da"]])

export default __exports__